import SubscriptionGraphics             from     "./section-one/SubscrptionGraphics.js"
import SubscriptionPayment              from     "./section-one/SubscriptionPayment.js"
import SubscriptionButtons              from     "./section-one/SubscriptionButtons.js"




const SubscriptionSectionOne = ( { subscription, paymentMethod } ) => {

    return (
        <>
            {/* [Section One] Body} */}
            <SubscriptionGraphics   subscription={subscription}                               />
            <SubscriptionPayment    subscription={subscription} paymentMethod={paymentMethod} />
            <SubscriptionButtons    subscription={subscription}                               />
        </>
    )
}


export default SubscriptionSectionOne